/* eslint-disable react-hooks/exhaustive-deps */
import React from 'react';
import { CustomersAutoTreatContext } from '../contexts/CustomersAutoTreatContext';
import CustomerAutoTreatForm from './CustomerAutoTreatForm';

interface CustomerAutoTreatDetailProps {
  onBack?: () => void;
}

const CustomersAutoTreatDetail: React.FC<CustomerAutoTreatDetailProps> = (props) => {
  const { onBack } = props;

  const { setDetailPage, activeCustomerAutoTreat, activeMachine } = React.useContext(CustomersAutoTreatContext);

  return (
    <>
      <br />
      <CustomerAutoTreatForm
        customer={activeCustomerAutoTreat}
        machineSerial={activeMachine?.value}
        onSuccess={() => setDetailPage(false)}
        onBack={onBack}
      />
    </>
  );
};

export default CustomersAutoTreatDetail;
